import stylesad2 from "../../pages/Admin/Admin2.module.css";
import DateService from "../../services/DateService";
import BtnSwitch from "../Button/BtnSwitch";
import {commentCheck, toggleComments} from "../../services/CommentService";
import stylesSwitch from "../Button/BtnSwitch.module.css";
import {Link} from "react-router-dom";
import Routing from "../../services/routing";
import React, {} from "react";
import {useModal} from "../../contexts/ModalContext";
import {
    generateAppleCalendarUrlForSeance,
    generateGoogleCalendarUrlForSeance, generateOffice365CalendarUrlForSeance,
    generateOutlookCalendarUrl,
    generateOutlookCalendarUrlForSeance,
    openCalendar, openCalendarForComment
} from "../../services/AgendaService";
import styles from "../../pages/Admin/Admin.module.css";
import SearchCoach from "../Search/SearchCoach";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { ReactComponent as OutlookIcon } from "../../icons/outlook.svg";
import { ReactComponent as GoogleAgendaIcon } from "../../icons/google_agenda.svg";
import { ReactComponent as Office365Icon } from "../../icons/office365.svg";

function Comment({ comment, urlGetComments, setComments }) {
    const {showModal, hideModal} = useModal();

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    let outurl = "";
    if (comment.dateNotif) {
        outurl = generateOutlookCalendarUrl({
            startDate: comment.dateNotif,
            endDate: comment.dateNotif,
            eventTitle: comment.title,
            eventDescription: comment.text,
            eventLocation: ""
        });
        console.log("outurl", outurl);
        // <Link to={outurl} target={"_blank"} >Ajouter à mon agenda OUTLOOK</Link>
    }

    // Action pour ouvrir le lien Outlook
    const handleOpenOutlookCalendar = () => {
        openCalendarForComment('outlook', {date: comment.dateNotif, title: comment.title, text: comment.text}, handleSuccess, handleError);
    };

    const handleOpenGoogleCalendar = () => {
        openCalendarForComment('google', {date: comment.dateNotif, title: comment.title, text: comment.text}, handleSuccess, handleError);
    }

    const handleOpenOffice365Calendar = () => {
        openCalendarForComment('office365', {date: comment.dateNotif, title: comment.title, text: comment.text}, handleSuccess, handleError);
    }

    function AgendaButtons() {
        return (
            <div style={{
                marginTop: '20px',
                padding: '15px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                textAlign: 'center'
            }}>
                <p style={{
                    margin: '0 0 15px 0',
                    fontSize: '0.9em',
                    color: '#666'
                }}>
                    📅 Ajoutez ce commentaire à votre agenda :
                </p>

                <div style={{
                    display: 'flex',
                    gap: '24px',
                    justifyContent: 'center',
                    flexWrap: 'wrap'
                }}>
                    <button
                        onClick={handleOpenOutlookCalendar}
                        className="btn btn_primary"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px',
                            backgroundColor: "#d1edff",
                            border: '1px solid #a0c4e6',
                            color: '#114c8a',
                            width: '120px',
                        }}
                    >
                        <OutlookIcon style={{ width: "48px", height: "48px"}}/>Outlook
                    </button>

                    <button
                        onClick={handleOpenGoogleCalendar}
                        className="btn btn_primary"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px',
                            color: '#114c8a',
                            backgroundColor: "#ffe398",
                            border: '1px solid #f0c14b',
                            width: '120px',
                        }}
                    >
                        <GoogleAgendaIcon style={{ width: "48px", height: "48px"}}/>Google Agenda
                    </button>

                    <button
                        onClick={handleOpenOffice365Calendar}
                        className="btn btn_primary"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px',
                            color: '#114c8a',
                            backgroundColor: "#ced5fa",
                            border: '1px solid #a0a8d3',
                            width: '120px',
                        }}
                    >
                        <Office365Icon style={{ width: "48px", height: "48px"}}/>Office 365
                    </button>
                </div>

                <p style={{
                    margin: '10px 0 0 0',
                    fontSize: '0.8em',
                    color: '#888'
                }}>
                    Compatible avec Outlook Web, Outlook Desktop, l'app mobile, Google Agenda et Office 365
                </p>
            </div>
        );
    }


    return <div key={comment.id} className={stylesad2.blok}>
        <div style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: "8px",
            marginBottom: "8px"
        }}>
            <div style={{display: "flex", flexDirection: "column", maxWidth: "350px"}}>
                <p style={{margin: "0 0 8px 0"}}>{comment.title}</p>
                <p style={{margin: "0 0 8px 0", fontSize: ".85rem"}}>{comment.text}</p>
                {comment.dateNotif && <p style={{
                    margin: "8px 0",
                    padding: "4px 6px",
                    borderRadius: "8px",
                    backgroundColor: "rgb(231, 237, 223)",
                    fontSize: "0.9rem",
                    width: "fit-content",
                    cursor: "pointer"
                }}
                onClick={() => {
                    // Open modal
                    showModal('classic', {
                        children:
                            <div style={{height: "auto", padding: "60px"}}>
                                <AgendaButtons />
                            </div>
                    });
                }}
                >
                    {/* TODO : lien vers agenda */}
                    Planifié pour le {DateService.formatDateJoli(comment.dateNotif)}
                </p>}
            </div>

            {(comment.check === true || comment.check === false) &&
                <div style={{minWidth: "60px"}}>
                    <BtnSwitch active={comment.check}
                               onToggle={async () => {
                                   await commentCheck(comment, (res) => {
                                       handleSuccess(res.data.message);
                                       toggleComments(urlGetComments, setComments, handleError);
                                   }, (err) => {
                                       console.error('error', err);
                                       handleError("Erreur : " + err);
                                   })
                               }}
                               activeLabel={"Traité"}
                               inactiveLabel={"À traiter"}
                               classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark} ${stylesSwitch.sliderSmall}`}
                               classNamesLabel={stylesSwitch.labelSmall}
                    />
                </div>
            }
            {/*
                            <button><FontAwesomeIcon icon={faXmark} /></button>
                            */}
        </div>

        <div style={{float: "right", fontSize: ".75rem"}}>
            <p>Créé le {DateService.formatDate(comment.createdAt)} </p>
            <p>par <Link to={Routing.generate({
                route: Routing.routes.adminUtilisateur,
                params: {utilisateurId: comment.createdBy.id}
            })}>{comment.createdBy.prenom} {comment.createdBy.nom} </Link></p>
        </div>
    </div>
}

export default Comment;